import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/* eslint-disable camelcase */

/* eslint-disable no-shadow */
import Vue from 'vue';
import Vuex from 'vuex';
import MagicService from '@/service/magic';
import TicketService from '@/service/ticket';
import { now } from '@vip-activity/business';
import PropsService from '../service/props';
import config from '@/config/index'; // 抽奖安全策略验证

import { shieldRun } from '@vip-activity/utils';
import axios from 'axios';
Vue.use(Vuex);
var state = {
  orderList: [],
  hasTicket: false,
  now: Date.now(),
  selectPayInfo: null,
  propsInfo: undefined,
  starRank: undefined,
  fansRanks: {},
  voteInfo: {},
  supportList: undefined,
  remainNum: 0,
  unlock: {},
  bookCouponState: -1,
  // -1：初始值 | 0:未领取 | 1：已领取 | 2：已领完
  abTestInfo: {},
  // 支付面板类型
  lookTaskInfo: undefined
};
var mutations = {
  setState: function setState(state, payload) {
    state[payload.state] = payload.value;
  }
};
var actions = {
  // 刷新抽奖信息（抽奖次数）
  refreshLotteryInfo: function refreshLotteryInfo(_ref) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, 互动抽奖ID, res, _res$data$left_num, leftNum;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              互动抽奖ID = window.setting.魔方配置.互动抽奖ID;
              _context.next = 4;
              return MagicService.getLotteryInfo({
                module_id: 互动抽奖ID
              });

            case 4:
              res = _context.sent;
              _res$data$left_num = res.data.left_num, leftNum = _res$data$left_num === void 0 ? 0 : _res$data$left_num;
              commit('setState', {
                state: 'remainNum',
                value: leftNum
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  // 获取订单列表
  getOrderList: function getOrderList(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit, res, _ref3, _ref3$order_infos, list;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              _context2.next = 3;
              return MagicService.getOrderList();

            case 3:
              res = _context2.sent;
              _ref3 = res || {}, _ref3$order_infos = _ref3.order_infos, list = _ref3$order_infos === void 0 ? [] : _ref3$order_infos;
              commit('setState', {
                state: 'orderList',
                value: (list || []).sort(function (a, b) {
                  return new Date(b.buy_time.replace(/-/g, '/')) - new Date(a.buy_time.replace(/-/g, '/'));
                })
              });

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  getTicketInfo: function getTicketInfo(_ref4) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, val;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref4.commit;
              _context3.next = 3;
              return MagicService.pkgInfo().then(function (res) {
                return +res.packet_adopt === 1;
              }).catch(function () {
                return false;
              });

            case 3:
              val = _context3.sent;

              if (val) {
                _context3.next = 8;
                break;
              }

              _context3.next = 7;
              return TicketService.getHasDianboTicket().then(function (res) {
                return !!res.cidBuyCheck;
              }).catch(function () {
                return false;
              });

            case 7:
              val = _context3.sent;

            case 8:
              commit('setState', {
                state: 'hasTicket',
                value: val
              });

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  // 道具
  getMyProps: function getMyProps(_ref5) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var commit, val, res;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref5.commit;
              val = state.propsInfo || null;
              _context4.prev = 2;
              _context4.next = 5;
              return PropsService.getMyProps();

            case 5:
              res = _context4.sent;
              val = res.list;
              _context4.next = 12;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](2);
              console.error(_context4.t0);

            case 12:
              commit('setState', {
                state: 'propsInfo',
                value: val
              });

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 9]]);
    }))();
  },
  getStarRanks: function getStarRanks(_ref6) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var commit, val, res;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref6.commit;
              val = state.starRank || null;
              _context5.prev = 2;
              _context5.next = 5;
              return PropsService.getStarRanks();

            case 5:
              res = _context5.sent;
              val = res.rankItems;

              if (res.curTime) {
                commit('setState', {
                  state: 'now',
                  value: res.curTime * 1000
                });
              }

              _context5.next = 13;
              break;

            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](2);
              console.error(_context5.t0);

            case 13:
              commit('setState', {
                state: 'starRank',
                value: val
              });

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 10]]);
    }))();
  },
  getFansRanks: function getFansRanks(_ref7, id) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var commit, val, res;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref7.commit;
              val = state.fansRanks || null;
              _context6.prev = 2;
              _context6.next = 5;
              return PropsService.getFansRanks(id);

            case 5:
              res = _context6.sent;
              val = res.rankItems;

              if (res.curTime) {
                commit('setState', {
                  state: 'now',
                  value: res.curTime * 1000
                });
              }

              _context6.next = 13;
              break;

            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](2);
              console.error(_context6.t0);

            case 13:
              commit('setState', {
                state: 'fansRanks',
                value: _objectSpread(_objectSpread({}, state.fansRanks), {}, _defineProperty({}, id || 'all', val))
              });

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[2, 10]]);
    }))();
  },
  getMyVoteInfo: function getMyVoteInfo(_ref8, params) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var commit, res, id;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref8.commit;
              _context7.prev = 1;
              _context7.next = 4;
              return PropsService.getMyVoteInfo(params);

            case 4:
              res = _context7.sent;

              if (res.curTime) {
                commit('setState', {
                  state: 'now',
                  value: res.curTime * 1000
                });
              }

              id = (params === null || params === void 0 ? void 0 : params.recipientID) || 'all'; // 不传指定明星的时候才能拿到用户投的所有的明星的信息

              if (res.starItems && !(params !== null && params !== void 0 && params.recipientID)) {
                commit('setState', {
                  state: 'supportList',
                  value: res.starItems
                });
              }

              commit('setState', {
                state: 'voteInfo',
                value: _objectSpread(_objectSpread({}, state.voteInfo), {}, _defineProperty({}, id, {
                  rank: res.myRank,
                  popularity: res.myPopularity
                }))
              });
              _context7.next = 14;
              break;

            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](1);
              console.error(_context7.t0);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[1, 11]]);
    }))();
  },
  getNow: function getNow(_ref9) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      var commit, time;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              commit = _ref9.commit;
              time = Date.now();
              _context8.prev = 2;
              _context8.next = 5;
              return now();

            case 5:
              time = _context8.sent;
              _context8.next = 11;
              break;

            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8["catch"](2);
              console.log(_context8.t0);

            case 11:
              commit('setState', {
                state: 'now',
                value: time
              });

            case 12:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[2, 8]]);
    }))();
  },
  unlock: function unlock(_ref10, _ref11) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      var commit, starid, moduleId, key, result, res, code;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref10.commit;
              starid = _ref11.starid, moduleId = _ref11.moduleId, key = _ref11.key;

              if (moduleId) {
                _context9.next = 4;
                break;
              }

              return _context9.abrupt("return");

            case 4:
              console.log('-----解锁-----', key, starid, moduleId);
              result = false;
              _context9.prev = 6;
              _context9.next = 9;
              return MagicService.lottery({
                module_id: moduleId
              });

            case 9:
              res = _context9.sent;

              if (res.data) {
                code = +res.data.sys_code;

                if ([0, -903].includes(code)) {
                  result = true;
                }
              }

              _context9.next = 15;
              break;

            case 13:
              _context9.prev = 13;
              _context9.t0 = _context9["catch"](6);

            case 15:
              commit('setState', {
                state: 'unlock',
                value: _objectSpread(_objectSpread({}, state.unlock), {}, _defineProperty({}, starid, _objectSpread(_objectSpread({}, state.unlock[starid]), {}, _defineProperty({}, key, result))))
              });

            case 16:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[6, 13]]);
    }))();
  },
  getBookCouponState: function getBookCouponState(_ref12) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
      var commit, moduleId, state, _res$data, res, _res$data2;

      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit = _ref12.commit;
              moduleId = window.setting.魔方配置.书券ID;
              state = 0;
              _context10.prev = 3;
              _context10.next = 6;
              return MagicService.getReceiveInfo({
                module_id: moduleId
              });

            case 6:
              res = _context10.sent;

              if ((_res$data = res.data) !== null && _res$data !== void 0 && _res$data.status) {
                state = +((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.status);
              }

              _context10.next = 12;
              break;

            case 10:
              _context10.prev = 10;
              _context10.t0 = _context10["catch"](3);

            case 12:
              commit('setState', {
                state: 'bookCouponState',
                value: state
              });

            case 13:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[3, 10]]);
    }))();
  },
  getLookTaskState: function getLookTaskState(_ref13) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
      var commit, moduleId, val, res;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              commit = _ref13.commit;
              moduleId = window.setting.魔方配置.观看任务ID;
              val = null;
              _context11.prev = 3;
              _context11.next = 6;
              return MagicService.getLotteryInfo({
                module_id: moduleId
              });

            case 6:
              res = _context11.sent;
              val = res.data;
              _context11.next = 12;
              break;

            case 10:
              _context11.prev = 10;
              _context11.t0 = _context11["catch"](3);

            case 12:
              commit('setState', {
                state: 'lookTaskInfo',
                value: val
              });

            case 13:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[3, 10]]);
    }))();
  },
  // 下发魂力，查询道具抽奖次数，抽奖下发道具（魂力）
  issuePower: function issuePower() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
      var time, issue, _issue;

      return regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _issue = function _issue3() {
                _issue = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                  var 观看任务ID, info, _info$data$left_num, leftNum, list, resList, failList, shieldList;

                  return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                      switch (_context13.prev = _context13.next) {
                        case 0:
                          time += 1;

                          if (!(time > 10)) {
                            _context13.next = 3;
                            break;
                          }

                          return _context13.abrupt("return");

                        case 3:
                          // 查询当前循环剩余抽奖次数
                          观看任务ID = window.setting.魔方配置.观看任务ID;
                          _context13.next = 6;
                          return MagicService.getLotteryInfo({
                            module_id: 观看任务ID
                          });

                        case 6:
                          info = _context13.sent;
                          _info$data$left_num = info.data.left_num, leftNum = _info$data$left_num === void 0 ? 0 : _info$data$left_num;
                          console.log("\u7B2C".concat(time, "\u6B21\u5FAA\u73AF\uFF0C\u6570\u91CF").concat(leftNum));

                          if (!(leftNum === 0)) {
                            _context13.next = 11;
                            break;
                          }

                          return _context13.abrupt("return");

                        case 11:
                          // 构造promise函数，下发魂力
                          list = _toConsumableArray(Array(leftNum)).map(function () {
                            return new Promise(function (resolve) {
                              MagicService.lottery({
                                module_id: 观看任务ID
                              }).then(function (res) {
                                var ret = res.ret,
                                    _res$data3 = res.data;
                                _res$data3 = _res$data3 === void 0 ? {} : _res$data3;
                                var sysCode = _res$data3.sys_code; // 抽奖成功[0] 或者当前已经抽奖 [-903]

                                resolve(+ret === 0 && +sysCode === 0 ? 0 : res);
                              }).catch(function (e) {
                                console.log(e);
                                resolve(e);
                              });
                            });
                          }); // 判断结果

                          _context13.next = 14;
                          return Promise.all(list);

                        case 14:
                          resList = _context13.sent;
                          // 失败列表
                          failList = resList.filter(function (v) {
                            return v !== 0;
                          }); // 安全策略未通过列表

                          shieldList = failList.filter(function (v) {
                            return +(v === null || v === void 0 ? void 0 : v.ret) === -905;
                          }); // 安全策略检查

                          if (!(shieldList.length > 0)) {
                            _context13.next = 21;
                            break;
                          }

                          shieldRun(shieldList[0].security_verify, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                              while (1) {
                                switch (_context12.prev = _context12.next) {
                                  case 0:
                                    _context12.next = 2;
                                    return issue();

                                  case 2:
                                  case "end":
                                    return _context12.stop();
                                }
                              }
                            }, _callee12);
                          })));
                          _context13.next = 24;
                          break;

                        case 21:
                          if (!(failList.length > 0)) {
                            _context13.next = 24;
                            break;
                          }

                          _context13.next = 24;
                          return issue();

                        case 24:
                        case "end":
                          return _context13.stop();
                      }
                    }
                  }, _callee13);
                }));
                return _issue.apply(this, arguments);
              };

              issue = function _issue2() {
                return _issue.apply(this, arguments);
              };

              time = 0;
              _context14.next = 5;
              return issue();

            case 5:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }))();
  },
  // 请求支付面板的AB Test
  getAbTestResult: function getAbTestResult(_ref15) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
      var commit, state, url, option, res, _ref16, _ref16$data, ret, result, GrayPolicyId;

      return regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              commit = _ref15.commit, state = _ref15.state;
              url = 'https://vip.video.qq.com/rpc/trpc.magic.trpc_abtest.Abtest/GetAbTestResult';
              option = {
                method: 'post',
                url: url,
                params: {
                  senceId: 1002
                },
                withCredentials: true
              };
              _context15.next = 5;
              return axios(option);

            case 5:
              res = _context15.sent;
              _ref16 = res || {}, _ref16$data = _ref16.data, ret = _ref16$data.ret, result = _ref16$data.result, GrayPolicyId = _ref16$data.GrayPolicyId;
              commit('setState', {
                state: 'abTestInfo',
                value: +ret === 0 ? {
                  result: result,
                  GrayPolicyId: GrayPolicyId
                } : state.abTestInfo
              });

            case 8:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }))();
  }
};
var getters = {
  isLive: function isLive(state) {
    var liveItem = window.setting.时间线[1];
    return liveItem ? liveItem.结束时间 >= state.now && liveItem.开始时间 <= state.now : false;
  },
  isLiveEnd: function isLiveEnd(state) {
    var liveItem = window.setting.时间线[1];
    return liveItem ? liveItem.结束时间 < state.now : false;
  },
  mySupportCount: function mySupportCount() {
    return function () {
      var _state$orderList = state.orderList,
          orderList = _state$orderList === void 0 ? [] : _state$orderList;
      var total = 0;
      orderList.forEach(function (item) {
        var _item$ReceiveList;

        var hasSelf = (_item$ReceiveList = item.ReceiveList) === null || _item$ReceiveList === void 0 ? void 0 : _item$ReceiveList.find(function (item) {
          return +item.vuserid === config.vuid;
        });
        total += item.total_num;

        if (hasSelf) {
          total -= 1;
        }
      });
      return total;
    };
  },
  starList: function starList(state) {
    var starRank = state.starRank || [];
    var starConfig = window.setting.道具配置.明星列表;
    var result = starRank.map(function (item) {
      var config = starConfig.find(function (config) {
        return "".concat(config.id) === "".concat(item.id);
      });
      return _objectSpread(_objectSpread({}, item), config);
    });
    starConfig.forEach(function (config) {
      if (!result.find(function (item) {
        return "".concat(config.id) === "".concat(item.id);
      })) {
        result.push(config);
      }
    });
    return result;
  },
  myPropsNum: function myPropsNum(state) {
    var info = state.propsInfo;
    var propId = window.setting.道具配置.道具id;

    if (Array.isArray(info)) {
      var item = info.find(function (item) {
        return item.id === propId;
      });
      return item && item.num || 0;
    }

    return 0;
  },
  theMostLikeStar: function theMostLikeStar(state, getters) {
    var supportList = state.supportList || [];
    var starList = getters.starList;
    var star = {
      popularity: 0
    };
    supportList.forEach(function (item) {
      if (star.popularity < item.popularity) {
        star = item;
      }
    });
    return starList.find(function (item) {
      return "".concat(item.id) === "".concat(star.id);
    });
  }
};
export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});